import { getValue, getLineCount } from 'lib/value'
import { getAnswerDisplayText } from './answerDisplayText'

export const COLLAPSE_POST_LENGTH = 400
export const COLLAPSE_POST_MAX_LINES = 10
export const COLLAPSE_POST_VISUAL_LINE_LIMIT = 16
export const COLLAPSE_POST_CHARS_PER_VISUAL_LINE = 72

export function estimateCollapsedAnswerVisualLines(answer) {
    const value = getValue(answer)
    const explicitLines = getLineCount(value) || 0
    const text = getAnswerDisplayText(answer)
    const paragraphs = String(text || '').split('\n')
    const wrappedLines = paragraphs.reduce(
        (sum, paragraph) =>
            sum + Math.max(1, Math.ceil(paragraph.length / COLLAPSE_POST_CHARS_PER_VISUAL_LINE)),
        0,
    )

    return Math.max(explicitLines, wrappedLines)
}

export function shouldCollapseAnswerText(answer) {
    const value = getValue(answer)
    const text = getAnswerDisplayText(answer)
    const textLength = text.length
    const lineCount = getLineCount(value) || 0
    const visualLineCount = estimateCollapsedAnswerVisualLines(answer)
    return (
        textLength > COLLAPSE_POST_LENGTH ||
        lineCount > COLLAPSE_POST_MAX_LINES ||
        visualLineCount > COLLAPSE_POST_VISUAL_LINE_LIMIT
    )
}
